import { api } from "constants/RotasAPI";
import usePost from "hooks/usePost";
import { queryClient } from "shared/util/queryClient";
import { AssinanteDocumentoDTO } from "types/dto/groupsign/AssinanteDocumentoDTO";

export const usePostcriarAssinanteDocumento = () => {
  const onSuccess = () => {
    queryClient.invalidateQueries("post-assinante-documento");
  };

  return usePost<AssinanteDocumentoDTO>({
    url: api.groupsign.assinanteDocumento,
    onSuccess,
  });
};
